export const comments_3357258 = {"data":{"data":[],"links":{}}}